import $ from 'jquery';
import CustomEvent from 'custom-event';
import {
    WSD,
    Backend,
    build_api_url,
    calculateAge,
    inGamecenter,
    isVkPlay,
    isMyGames,
    isMobile,
    isMyGamesApp,
    Domains
} from '@vkplay/shared';
import * as Sentry from '@sentry/browser';
import './css/main/style.css';
import './ovl.css';
import 'script-loader!./mailru.core.js';
import './mailru.api.js';

const isProduction = document.domain === 'store.my.games' || document.domain === 'vkplay.ru';
const search = new URLSearchParams(location.search);
const debug = search.get('debug_pwa') === '1';

function getDisplayMode() {
    let displayMode = 'browser';
    const mqStandAlone = '(display-mode: standalone)';

    if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
        displayMode = 'PWA';
    }

    return displayMode;
}

window.getDisplayMode = getDisplayMode;

(function triggerDisplayModeEvent() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'display_mode_init',
        displayMode: getDisplayMode(),
    });
})();

const setAppHeight = () => {
    const doc = document.documentElement;

    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

if (isProduction && isVkPlay) {
    Sentry.init({
        dsn: 'https://f6280967b69440c68d0bf346488b7192@store-sentry.vkplay.ru/119',
        ignoreErrors: [
            'Request has been terminated',
            'has been blocked by CORS policy',
            'invalid message received by the iframe API'
        ]
    });
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/app/3800/static/build/sw.js', {scope: '/app/'})
    .then((reg) => {
        console.debug('%cService Worker registration succeeded. Scope is ' + reg.scope, 'color:blue');
    }).catch((error) => {
        console.debug('%cRegistration failed with ' + error, 'color:red');
    });
}

function triggerPWAEvent(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event, PWAppID: window.appid});
}

window.addEventListener('appinstalled', () => {
    triggerPWAEvent('pwa_installed');
});

let deferredPWAPrompt;

const promisedPrompt = new Promise((resolve) => {
    $(window).one('beforeinstallprompt', (e) => {

        if (window.appid === 5339 || window.appid === 5356 || window.appid === 5406 || isMyGames) {
            e.preventDefault();
        } else {
            triggerPWAEvent('pwa_ready');
        }

        deferredPWAPrompt = e.originalEvent; // сохраняем событие на потом
        resolve();
    });
});

const promisedMessage = new Promise((resolve) => {
    $(window).on('message', (e) => {
        const data = e.originalEvent.data || e.originalEvent.message;

        if (!data) {
            return;
        }

        if (data === 'iframeAppReady') { // Приложение готово принимать события
            resolve();
        }

        if (data === 'pwaFromIframe') { // Пользователь нажал на "установить" внутри фрейма
            deferredPWAPrompt.prompt();
        }
    });
});

Promise.all([promisedPrompt, promisedMessage]).then(() => {
    const $iframe = $('iframe')[0];

    if (!$iframe || !$iframe.contentWindow || isMyGames || (isMobile && !window.is_app_mobile)) {
        return;
    }

    triggerPWAEvent('pwa_ready');

    $iframe.contentWindow.postMessage('pwaInstallReady', '*');
});

function onWSD(wsd) {
    window.WSD = wsd;
    const event = new CustomEvent('DOMContentLoaded');
    document.dispatchEvent(event);
    $(window).trigger('WSDInit');
}

window.onWsd = onWSD;

function onGemLogin() {
    if (window.__gem_wsd) {
        onWSD(window.__gem_wsd);
    }

    if (window.partnerTrackOnline) {
        trackOnline();
    }

    if (hasAgeLimit()) {
        handleAgeLimitRedirect();
    }
}

function getProfile (callback) {
    Backend.api_get('/social/profile/v2/session', {
        rnd: Math.random()
    }).then((resp) => {
        let profile = resp.profile || {},
            email = profile.user_id;

        if (email) {
            WSD.init(email, Domains.wsd);
            onWSD(WSD);
        }

        callback && callback(profile);
    })
    .catch((error) => {
        console.warn(error);
        callback && callback();
    });
}

function loadScript(src, callback) {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = src;
    script.onload = callback;
    // use body if available. more safe in IE
    (document.body || document.head).appendChild(script);
}

function addListener(element, eventName, handler) {
    if (element.addEventListener) {
        return element.addEventListener(eventName, handler, false);
    } else {
        return element.attachEvent('on' + eventName, handler);
    }
}

function trackOnline() {
    function _prepare_url(status) {
        if (!status) {
            status = 'online';
        }
        return build_api_url('/social/online/set')
            + '?project_id=' + encodeURIComponent(window.appid)
            + '&type=gmr'
            + '&' + status + '=1'
            + '&rnd=' + Math.random();
    }

    function _setStatus(status) {
        const src = _prepare_url(status);

        if (navigator && navigator.sendBeacon) {
            const blob = new Blob([''], {type: 'application/json'});
            navigator.sendBeacon(src, blob);
        } else {
            loadScript(src);
        }
    }

    addListener(window, 'unload', function () {
        _setStatus('offline');
    });
    setInterval(_setStatus, 1000 * 60 * 10);
    _setStatus();
}

window.trackOnline = trackOnline;

function updatePageHeight () {
    const header = document.getElementById('js-b-header'); // Шапка GMR/MY.GAMES/VK Play
    const mainBlock = $('#promo'); // Основной iframe с игрой
    const reviewsWidget = $('.js-reviews-widget'); // Виджет отзывов/мобильное меню для азерионовских игр
    const reviewsWidgetHeight = !window.matchMedia('(orientation: landscape)').matches && reviewsWidget.outerHeight() || 0;
    const browserWarning = $('.js-browser-warning:visible'); // Предупреждение об устаревшем браузере
    const browserWarningHeight = browserWarning.outerHeight() || 0;
    const flashWarning = $('.js-flash-warning'); // Предупреждение о недоступности flash-игр в браузере
    const flashWarningHeight = flashWarning.outerHeight() || 0;
    const subscriptionsHeight = $('#root-subscription').outerHeight() || 0;
    const height = `${window.innerHeight - header.offsetHeight - subscriptionsHeight - reviewsWidgetHeight - browserWarningHeight - flashWarningHeight}px`;

    mainBlock.css({ height });
};
window.partner_resize = updatePageHeight;


function build_download_url(gc_id) {
    const id = gc_id.toString().split('.');

    return `https://static.gc.my.games/${isVkPlay ? 'VKPlayLoader' : 'MyGamesLoader'}_${id[0]}_${id[1]}Chnl58a.exe`;
}

function getGame(callback) {
    if (!callback) {
        return;
    }

    Backend.api_get('/play/games/get/', {
        id: window.appid
    })
        .then((response) => {
            callback(response);
        })
        .catch((error) => {
            console.warn(error);
        });
}

function getGameForReviews() {
    const reviewsWidget = $('.js-reviews-widget');
    const reviewsWidgetRating = $('.js-reviews-widget__rating');
    const getRatingClassname = (num) => `b-reviews-widget__rating_${num}`;
    const reviewsWidgetBtn = $('.js-review-widget-btn');

    getGame((game) => {
        const { slug, avg_rating } = game;
        const url = reviewsWidgetBtn.attr('href');

        reviewsWidget.show();
        reviewsWidgetBtn.attr('href', url + slug + '/?show_add_review=1');
        reviewsWidgetRating.addClass(getRatingClassname(Math.floor(avg_rating)));

        if (avg_rating > 0) {
            reviewsWidgetRating.html(avg_rating);
        }
    });

    reviewsWidgetBtn.on('click', () => {
        reviewsWidget.hide();
    });
}

const AGE_LIMIT_REGIONS = [
    '50', // UK
    '200', // USA
];

function hasAgeLimit() {
    const user = window.current_user;
    const ageLimit = parseInt(window.age_limit);
    const enableRegionRestrictions = AGE_LIMIT_REGIONS.includes(window.country_id);

    const profile_fields = user?.profile_fields || {};
    const { birthday, child } = profile_fields;

    if (!birthday || child !== '1' || !enableRegionRestrictions) {
        return false;
    }

    const age = calculateAge(birthday);

    return window.age_limit_set && !isNaN(ageLimit) && age < ageLimit;
}

// Редиректить на детскую заглушку, если возраст юзера меньше возрастного ограничения игры
function handleAgeLimitRedirect() {
    // Не редиректить в ИЦ
    if (inGamecenter) {
        return;
    }

    // Получить slug игры для редиректа
    getGame((game) => {
        const { slug } = game;
        const newUrl = `${window.location.origin}/play/game/${slug}/`;

        window.location.replace(newUrl);
    })
}

if (window.IN_GAMECENTER) {
    // Get profile in gamecenter

    getProfile(function (profile) {
        if (window.partnerTrackOnline) {
            trackOnline();
        }
    });
} else {
    // Init wsd when header profile is loaded

    window.addEventListener('gem_login', () => {
        onGemLogin();
    });

    window.addEventListener('init_wsd', () => {
        onWSD(window.__gem_wsd);
    });
}

$(window).on('load resize orientationchange', function() {
    setAppHeight();
    updatePageHeight();
})

$(document).ready(function () {
    // Add pattern background
    if (location.pathname === '/app/3550') {
        $('.page').css({'background': 'url(//heroesru-a.akamaihd.net/iframe_v2/images/heroes-bg/pattern-fill-2.jpg) repeat'})
    }

    // Hide mobile widget in app

    if (isMyGamesApp) {
        $('.js-reviews-widget').remove();
        updatePageHeight();
    }

    // Draggie
    function createDraggie() {
        const elem = document.querySelector('.js-mobile-menu');

        if (!elem) {
            return null
        }

        const draggie = new Draggabilly(elem, {
            axis: 'y',
            handle: elem.querySelector('#drag')
        });

        window.draggie = draggie;
        let menuTop = 0;

        draggie.once('pointerDown', function (event, pointer) {
            menuTop = pointer.clientY;
        })

        // bind event listener
        draggie.on('dragMove', function (event, pointer) {

            if (draggie.position.y < menuTop) {
                draggie.dragEnd();
                draggie.setPosition(0, menuTop)
            }

            if (draggie.position.y > menuTop + 60) {
                draggie.dragEnd();
                draggie.destroy();
                hideMenu();
            }
        });
    }

    if (isMobile) {
        createDraggie();
    }

    // Show/hide browser warning

    const browserWarning = $('.js-browser-warning'),
        closeWarning = $('.js-browser-warning-close'),
        btnFullscreen = $('.btn-action--fullscreen'),
        ua = window.navigator.userAgent.toLowerCase(),
        desktopSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1 && navigator['maxTouchPoints'] === 0,
        mobileSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1 && navigator['maxTouchPoints'],
        showBrowserWarning = ua.indexOf('msie ') > -1 || ua.indexOf('trident/') > -1 || desktopSafari;

    if (mobileSafari) {
        btnFullscreen.hide();
    }

    let isBrowserWarningShown = false;

    if (browserWarning.length) {
        // Show warning in safari & IE if it wasn't closed before
        if (showBrowserWarning && !window.localStorage.getItem('browser_warning_closed')) {
            browserWarning.show();
            updatePageHeight();
            isBrowserWarningShown = true;
        }

        // Set localStorage value on warning close and don't show again
        closeWarning.on('click', () => {
            browserWarning.hide();
            updatePageHeight();
            window.localStorage.setItem('browser_warning_closed', '1');
        });
    }

    // Flash games alert

    if (window.showFlashNotification && !window.IN_GAMECENTER) {
        const flashNotif = $('.js-flash-warning'),
            closeFlashNotif = $('.js-flash-warning-close'),
            flashDate = window.localStorage.getItem(`flash_warning_closed_${window.appid}`),
            dateDiff = Date.now() - flashDate,
            showFlash = !flashDate || dateDiff >= 172800 * 1000; // 2 days

        if (showFlash && !isBrowserWarningShown) {
            flashNotif.show();
            updatePageHeight();
        }

        closeFlashNotif.on('click', () => {
            flashNotif.hide();
            updatePageHeight();
            window.localStorage.setItem(`flash_warning_closed_${window.appid}`, Date.now());
        });
    }

    // Play in Gamecenter btn

    const gcBtn = $('.js-gc-btn');

    gcBtn.on('click', () => {
        const gc_id = window.gc_id;

        // Detect GC and download

        const id = gc_id && gc_id.toString();

        if (!id) {
            throw new Error('No gc_id defined');
        }

        const url = build_download_url(id);

        if (window.EVA) {
            window.EVA.gc.detectAndDownload(id, url, 1, { isFlash: true });
        }
    });

    const goGamePageBtn = $('#redirect-game-page');
    const mobileMenuBtn = $('#mobile-menu-btn');

    // Tooltip for Azerion Games
    goGamePageBtn.hover(function(e){
        let titleText = $(this).attr('title');
        $(this).data('tiptext', titleText).removeAttr('title');
        $('<p class="tooltip"></p>').text(titleText).appendTo('body').css('top', (e.pageY) + 'px').css('left', (e.pageX - 150) + 'px').css('z-index', 10000).fadeIn('slow');
    }, function(){
        $(this).attr('title', $(this).data('tiptext'));
        $('.tooltip').remove();
    }).mousemove(function(e){
        $('.tooltip').css('top', (e.pageY) + 'px').css('left', (e.pageX - 150) + 'px');
    });

    document.querySelectorAll('a[data-game-href]').forEach(el => {
        getGame((game) => {
            const { slug } = game;
            const dataAttribute = el.dataset.gameHref;

            if (el.dataset.gameHref) {
                el.href = `/play/game/${slug}/${dataAttribute}`
            } else {
                el.href = `/play/game/${slug}`
            }
        });
    })

    const goToGamePage = (e) => {
        getGame((game) => {
            const { slug } = game;
            if (e.target.classList.contains('btn-action--info')) {
                window.open(`${location.origin}/play/game/${slug}`, '_blank');
            } else {
                e.target.href = `${location.origin}/play/game/${slug}`
            }
        });
    }

    goGamePageBtn.on('click', goToGamePage);

    function hideMenu() {
        const mobileMenu = $('.js-mobile-menu');
        const page = document.querySelector('.page');

        mobileMenu.removeClass('show');

        if (isMobile) {
            page.classList.remove('overlay');
        }

        mobileMenu.css('bottom', (-mobileMenu.outerHeight() - 20) + 'px');
    }

    function toggleMobileMenu() {
        const mobileMenu = document.querySelector('.js-mobile-menu');
        const page = document.querySelector('.page');
        const browserWarning = $('.js-browser-warning:visible');
        const header = document.getElementById('js-b-header');
        mobileMenu.classList.toggle('show');
        if (isMobile) {
            page.classList.toggle('overlay');

            if (!draggie.isEnabled) {
                createDraggie();
            }
        }

        if (mobileMenu.classList.contains('show')) {
            mobileMenu.style.bottom = header.offsetHeight + (browserWarning.outerHeight() || 0) + 'px';
            mobileMenu.style.transform = 'inherit';
        } else {
            mobileMenu.style.bottom = (-mobileMenu.offsetHeight - 20) + 'px'
        }
    }

    mobileMenuBtn.on('click', toggleMobileMenu)


    // Hide mobile-menu on click outside
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.js-mobile-menu').length
            && !$(event.target).is($('.btn-action'))
            && !$(event.target).is($('.b-reviews-widget'))
            && !$(event.target).is($('.b-reviews-widget__name'))) {
            window.draggie?.destroy();
            hideMenu();
        }
    });
});
